import { FC, ReactNode } from 'react';

import { useLocale } from '../../../../../../hooks/index';
import { Column, columnTitleMap } from '../template-table.types';
import { RowPayload } from './template-row.types';

const MOBILE_DETAIL_COLUMNS: Column[] = [Column.CATEGORY, Column.STATUS, Column.SIGNATORIES];

type MobileRowProps = {
  name: string;
  payload: RowPayload;
};

type DetailRowProps = {
  label: string;
  value: ReactNode;
};

const DetailRow: FC<DetailRowProps> = ({ label, value }) => (
  <div className="flex justify-between gap-3 border-t border-gray-100 px-3 py-3">
    <span className="w-[120px] shrink-0 text-sm font-normal text-gray-700">{label}</span>
    <span className="min-w-0 break-words text-right text-sm font-normal text-gray-700">
      {value}
    </span>
  </div>
);

export const MobileRow: FC<MobileRowProps> = ({ name, payload }) => {
  const { messagesLocale } = useLocale();

  return (
    <div className="flex h-fit w-full min-w-[300px] max-w-[440px] flex-col divide-y-[1px] divide-gray-100 rounded-md bg-white shadow-sm">
      <div className="flex flex-col gap-0.5 px-3 py-4">
        <div className="flex items-start justify-between gap-3">
          <h3
            className="min-w-0 flex-1 truncate text-base font-semibold text-gray-700"
            title={name}
          >
            {name}
          </h3>
        </div>
        <p className="text-sm font-normal text-gray-700">
          {messagesLocale['EDIT_ON']} {payload[Column.EDITED_ON]}
        </p>
      </div>

      <div>
        {MOBILE_DETAIL_COLUMNS.map((column) => (
          <DetailRow
            key={payload.id + column}
            label={messagesLocale[columnTitleMap[column]]}
            value={payload[column]}
          />
        ))}
      </div>
    </div>
  );
};
